import { createAction } from 'redux-actions';
import * as actionTypes from './planning-board-constants';

export const setViewMode = createAction(actionTypes.SET_VIEW_MODE);
export const setFullScreen = createAction(actionTypes.SET_FULLSCREEN);

export const toggleShowTravelTime = createAction(actionTypes.TOGGLE_SHOW_TRAVEL_TIME);

export const resetNotification = createAction(actionTypes.RESET_NOTIFICATION);
